import * as C from '../constants';
import coreService from '../../../services/core-service';
import giftVoucherService from '../../../services/gift-voucher-service/gift-voucher-service';
import downloadService from '../../../services/download-service';

export default {
  loadBrands({ commit, rootState }) {
    commit(C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_PENDING);
    coreService.getBrandsWithDomains()
      .then((response) => {
        if (response.status === 200) {
          const brandIds = rootState.app.auth.brands.map(brand => brand.id);
          const brands = [];
          Object.values(response.data)
            .forEach((brand) => {
              if (brandIds.indexOf(brand.id) !== -1) {
                brands.push(brand);
              }
            });
          commit(C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_SUCCESS, brands);
        } else {
          commit(C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_FAILURE);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_SEARCH_BRANDS_WITH_DOMAINS_FAILURE);
      });
  },
  searchGiftVouchers({ commit }, domainIds) {
    commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_PENDING);
    giftVoucherService.getGiftVouchersByDomainId(domainIds)
      .then((response) => {
        if (response.status === 204) {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_NOCONTENT);
        } else if (response.status === 200) {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_SUCCESS, response.data);
        } else {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_FAILURE);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_FAILURE);
      });
  },
  searchGiftVoucherByReference({ commit }, reference) {
    commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_PENDING);
    giftVoucherService.getGiftVouchersByReferenceWithBooking(reference)
      .then((response) => {
        if (response.status === 200) {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_SUCCESS, response.data);
        } else {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_FAILURE);
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_NOTFOUND);
        } else {
          commit(C.GIFT_VOUCHER_SEARCH_GIFT_VOUCHERS_REFERENCE_FAILURE);
        }
      });
  },
  cancelGiftVoucher({ commit, state }, reference) {
    return giftVoucherService.cancelGiftVoucher(reference).then(() => {
      const index = state.search.giftVouchers.items.findIndex(
        giftVoucher => giftVoucher.giftVoucher.voucherRef === reference,
      );
      commit(C.GIFT_VOUCHER_SEARCH_CANCEL_SUCCESS, index);
      return Promise.resolve();
    }).catch(() => Promise.reject());
  },
  downloadGiftVouchers(_, domainIds) {
    return giftVoucherService.downloadGiftVouchersByDomainId(domainIds)
      .then((res) => {
        downloadService.downloadCsv('gift_vouchers', res.data);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/gift-vouchers/actions.js